import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateOffset',
})
export class DateOffsetPipe implements PipeTransform {
    public transform(value: Date): Date {
        if (!value) {
            return value;
        }

        let date = new Date(value);

        if (!date.toISOString().includes('T00:00:00.000Z')) {
            let hoursDiff = date.getHours() - (date.getTimezoneOffset() / 60); // Adjust for hours
            let minutesDiff = date.getMinutes() - (date.getTimezoneOffset() % 60); // Adjust for minutes
            date.setHours(hoursDiff);
            date.setMinutes(minutesDiff);
        }

        return date;
    }
}
